import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { sendCodeFailed, sendCodeLoading, sendCodeSucceed } from './index';
import { EActiveView } from '../../types/view';
import { changeView } from '../view';
import { ESendTwoFactorCodeStatus, sendTwoFactorCodeMultichannel, ESenderType } from '../../api/sendTwoFactorCode';
export function sendCodeMultichannel() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var subdomain, state, phone, login, password, activeView, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            subdomain = context.subdomain;
            state = getState();
            phone = state.authentication.twoFactor.phoneState.phone;
            login = state.login;
            password = state.authentication.password;
            activeView = state.view.active;
            dispatch(sendCodeLoading());
            _context.next = 9;
            return sendTwoFactorCodeMultichannel(context, {
              subdomain: subdomain,
              phone: phone,
              login: login,
              password: password
            });
          case 9:
            result = _context.sent;
            if (!(result.status === ESendTwoFactorCodeStatus.Failed)) {
              _context.next = 13;
              break;
            }
            dispatch(sendCodeFailed(result.message));
            return _context.abrupt("return");
          case 13:
            dispatch(sendCodeSucceed(result));
            if (result.senderType === ESenderType.Sms && activeView !== EActiveView.TwoFactorPhoneValidateSms) {
              dispatch(changeView(EActiveView.TwoFactorPhoneValidateSms));
            }
            if (result.senderType === ESenderType.Call && activeView !== EActiveView.TwoFactorPhoneValidateCall) {
              dispatch(changeView(EActiveView.TwoFactorPhoneValidateCall));
            }
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}